// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/curve_fit_plot_data.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { CurveCoefficients } from "./curve_coefficients_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_curve_coefficients } from "./curve_coefficients_pb";
import type { CurveFitPlotPoint } from "./curve_fit_plot_point_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_point } from "./curve_fit_plot_point_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/curve_fit_plot_data.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_data: GenFile = /*@__PURE__*/
  fileDesc("CkFxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3VydmVfZml0X3Bsb3RfZGF0YS5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIpIFChBDdXJ2ZUZpdFBsb3REYXRhEiIKDWV4cGVyaW1lbnRfaWQYASABKAlCBoK1GAIYAUgAiAEBEh0KCGFzc2F5X2lkGAIgASgJQgaCtRgCGAFIAYgBARIcCgdwbGV4X2lkGAMgASgJQgaCtRgCGAFIAogBARJICgRkYXRhGAQgAygLMjoucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkN1cnZlRml0UGxvdFBvaW50Eh4KEWxvZF9jb25jZW50cmF0aW9uGAUgASgBSAOIAQESHwoSbGxvcV9jb25jZW50cmF0aW9uGAYgASgBSASIAQESHwoSdWxvcV9jb25jZW50cmF0aW9uGAcgASgBSAWIAQESFAoHbG9kX2FlYhgIIAEoAUgGiAEBEhUKCGxsb3FfYWViGAkgASgBSAeIAQESFQoIdWxvcV9hZWIYCiABKAFICIgBARJbChJjdXJ2ZV9jb2VmZmljaWVudHMYCyABKAsyOi5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuQ3VydmVDb2VmZmljaWVudHNICYgBARIWCglyX3NxdWFyZWQYDCABKAFICogBAUIQCg5fZXhwZXJpbWVudF9pZEILCglfYXNzYXlfaWRCCgoIX3BsZXhfaWRCFAoSX2xvZF9jb25jZW50cmF0aW9uQhUKE19sbG9xX2NvbmNlbnRyYXRpb25CFQoTX3Vsb3FfY29uY2VudHJhdGlvbkIKCghfbG9kX2FlYkILCglfbGxvcV9hZWJCCwoJX3Vsb3FfYWViQhUKE19jdXJ2ZV9jb2VmZmljaWVudHNCDAoKX3Jfc3F1YXJlZGIGcHJvdG8z", [file_quanterix_common_extensions_v1_field_options, file_quanterix_simoa_one_analysis_app_api_v1_curve_coefficients, file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_point]);

/**
 * Contains data for displaying a plot of fitted concentrations from
 * the analysis results for a single plex in an experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotData
 */
export type CurveFitPlotData = Message<"quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotData"> & {
  /**
   * Unique id (UUID) of the experiment that contains this data
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * Unique id (UUID) of the assay associated with this dataset
   *
   * @generated from field: optional string assay_id = 2;
   */
  assayId?: string;

  /**
   * Unique id (UUID) of the plex (analyte) associated with this dataset
   *
   * @generated from field: optional string plex_id = 3;
   */
  plexId?: string;

  /**
   * Plot data - a collection of labeled plot points
   *
   * @generated from field: repeated quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotPoint data = 4;
   */
  data: CurveFitPlotPoint[];

  /**
   * Limit of detection along the concentration axis
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.AssayLimits
   *
   * @generated from field: optional double lod_concentration = 5;
   */
  lodConcentration?: number;

  /**
   * Lower limit of quantification along the concentration axis
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.AssayLimits
   *
   * @generated from field: optional double lloq_concentration = 6;
   */
  lloqConcentration?: number;

  /**
   * Upper limit of quantification along the concentration axis
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.AssayLimits
   *
   * @generated from field: optional double uloq_concentration = 7;
   */
  uloqConcentration?: number;

  /**
   * Limit of detection along the AEB axis
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.AssayLimits
   *
   * @generated from field: optional double lod_aeb = 8;
   */
  lodAeb?: number;

  /**
   * Lower limit of quantification along the AEB axis
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.AssayLimits
   *
   * @generated from field: optional double lloq_aeb = 9;
   */
  lloqAeb?: number;

  /**
   * Upper limit of quantification along the AEB axis
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.AssayLimits
   *
   * @generated from field: optional double uloq_aeb = 10;
   */
  uloqAeb?: number;

  /**
   * Coefficients of the fitted calibration curve of this plot
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.CurveParameterOptions
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.CurveCoefficients curve_coefficients = 11;
   */
  curveCoefficients?: CurveCoefficients;

  /**
   * Coefficient of determination
   *
   * @seealso quanterix.simoa_one.analysis_app_api.v1.EvaluatedCurveParameters
   *
   * @generated from field: optional double r_squared = 12;
   */
  rSquared?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CurveFitPlotData.
 * Use `create(CurveFitPlotDataSchema)` to create a new message.
 */
export const CurveFitPlotDataSchema: GenMessage<CurveFitPlotData> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_curve_fit_plot_data, 0);

